export default __webpack_public_path__ + "static/media/deauville12.42e79674.jpg";